$(() => {
  const $dropdownLinkCopy = $('[data-js-social-link-copy]');

  const stopMenuClose = (e) => {
    e.stopPropagation();
  };

  const init = () => {
    $dropdownLinkCopy.on('click', stopMenuClose);
  };

  init();
});
